var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.$route.query.type == 0 ? '培养目标' : '详细说明'}}),_vm._v(" "),_c('div',{staticClass:"courseDetails"},[_c('article',{domProps:{"innerHTML":_vm._s(_vm.$route.query.type == 0 ? _vm.detailList.target : _vm.detailList.explain)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bdd0ffe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/student/Cultivate/courseAdd.vue
// module id = null
// module chunks = 